var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rightItem"},[_c('region'),_c('organization'),_c('div',{staticClass:"right-bottom-box"},[_c('safe'),_c('monitor')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }